import { RequestedFile } from '../types'
import { MeasureResult } from './types'

export const getMeasures = (
  window: Window,
  domains: string[],
): MeasureResult => {
  let resources: PerformanceResourceTiming[] = []
  let measures: PerformanceMeasure[] = []

  if (window.performance?.getEntriesByType) {
    resources = window.performance.getEntriesByType(
      'resource',
    ) as PerformanceResourceTiming[]
    measures = window.performance.getEntriesByType(
      'measure',
    ) as PerformanceMeasure[]
  }

  const mappedResources = resources.map((current) => {
    const isRequest = current.name.startsWith('http')
    let urlFragments: RegExpMatchArray | null

    if (isRequest) {
      urlFragments = current.name.match(/:\/\/(.[^/]+)([^?]*)\??(.*)/)
    } else {
      urlFragments = ['', location.host]
    }

    return {
      name: current.name,
      domain: urlFragments?.[1],
      transferSize: current.transferSize,
      loadTime: String(current.duration),
      startTime: current.startTime,
      responseEnd: current.responseEnd,
      initiatorType: current.initiatorType,
    } as RequestedFile
  })

  const requests = mappedResources.filter(
    (res) => res.name.startsWith('http') && !res.name.endsWith('js.map'),
  )

  const filteredRequests = requests.filter((req) =>
    domains.includes(req.domain),
  )

  const maxResponseTime = Math.max(
    ...filteredRequests.map((r) => r.responseEnd),
  )
  const minResponseTime = Math.min(
    ...filteredRequests.map((r) => r.responseEnd),
  )
  const contentLoadTime = maxResponseTime - minResponseTime

  return { requests, contentLoadTime }
}
